import React from "react"

const DarkmodeContext = React.createContext(false)

export default DarkmodeContext